import { find, forEach, isEmpty } from "lodash";

const getTopLevelProdCats = (productCategories) => {
    const topLevel = [];

    forEach(productCategories, (productCategory) => {
        const ancestors = productCategory?.ancestors;
        if (isEmpty(ancestors)) {
            topLevel.push(productCategory.slug);
        }
    });

    return topLevel;
};

const getProductLine = (productLines) => {
    const productLine = [];

    const line = find(productLines, (productLine) => !isEmpty(productLine));

    if (line) {
        productLine.push(line.slug);
    }

    return productLine;
};

const getSubLevelProdCats = (productCategories) => {
    const subLevel = [];

    forEach(productCategories, (productCategory) => {
        const ancestors = productCategory?.ancestors;
        if (!isEmpty(ancestors)) {
            subLevel.push(productCategory.slug);
        }
    });

    return subLevel;
};

export const createCTAPriorityList = (productLines, productCategories) => {
    const topLevel = getTopLevelProdCats(productCategories);
    const productLine = getProductLine(productLines);
    const subLevel = getSubLevelProdCats(productCategories);

    const priorityList = new Set([...topLevel, ...productLine, ...subLevel]);

    return Array.from(priorityList);
};
